import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums'

@Injectable({
  providedIn: 'root'
})
export class AziendaService extends BaseService {
  /**
     * Costruttore
     * @param http Servizio di richieste HTTP 
     */
  constructor(http: Http) {
    super(http);
  }

  /**
   * get all aggiudicatari
   * @param reqBuilder data
   */
  getAllAzienda(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('azienda/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * get all aggiudicatari
   * @param reqBuilder data
   */
  getAllAziendaCommessa(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('azienda/fetchAziendaCommessa', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * get all aziende
   * @param reqBuilder data
   */
  getAllEsecutori(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('azienda/FetchAziendaByUtente', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * export all aziende censite
   * @param reqBuilder 
   */
  exportFiliera(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('azienda/exportCensimentoAziende', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

}